/**
 * @generated SignedSource<<fffbe390fe005673f6d9d3624fa40968>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductExpireBatch_ProductExpireBatch$data = {
  readonly expireAtDate: {
    readonly isoString: string;
  };
  readonly id: string;
  readonly product: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchDatePicker_StoreProduct" | "ProductExpireBatchProductPreview_StoreProduct">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchActionList_productExpireBatch" | "ProductExpireBatchStatusFooter_productExpireBatch">;
  readonly " $fragmentType": "ProductExpireBatch_ProductExpireBatch";
};
export type ProductExpireBatch_ProductExpireBatch$key = {
  readonly " $data"?: ProductExpireBatch_ProductExpireBatch$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatch_ProductExpireBatch">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductExpireBatch_ProductExpireBatch",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "expireAtDate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isoString",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "StoreProduct",
        "kind": "LinkedField",
        "name": "product",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductExpireBatchDatePicker_StoreProduct"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductExpireBatchProductPreview_StoreProduct"
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductExpireBatchActionList_productExpireBatch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductExpireBatchStatusFooter_productExpireBatch"
    }
  ],
  "type": "StoreProductExpireBatch",
  "abstractKey": null
};
})();

(node as any).hash = "acf3925b62d9a848afb6d14e8228c0c5";

export default node;
